import type { Quota } from '../types';

const DAILY_LIMIT_MESSAGE =
  'You have reached your daily upload limit. Please try again tomorrow or upgrade your plan.';

const MINUTES_LIMIT_MESSAGE =
  'You do not have enough transcription minutes remaining for this file. Please upgrade your plan or try a shorter file.';

export function assertUploadAllowedByQuota(quota: Quota, estimatedDurationSeconds?: number): void {
  if (!quota.can_upload_today) {
    throw new Error(DAILY_LIMIT_MESSAGE);
  }

  if (!Number.isFinite(estimatedDurationSeconds)) {
    return;
  }

  const requiredMinutes = Math.max(0, (estimatedDurationSeconds ?? 0) / 60);
  if (requiredMinutes <= 0) {
    return;
  }

  if (quota.remaining_minutes < requiredMinutes) {
    throw new Error(MINUTES_LIMIT_MESSAGE);
  }
}

